// Client-side checks that mirror the server's rules, so a person sees the problem before sending. The server still
// validates everything; these only save a round trip and give a clearer message.

/** Same shape the API accepts (zod `.email()`): local@domain.tld, no spaces, no empty or consecutive dots. */
const EMAIL = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9-]*\.)+[A-Za-z]{2,}$/;

export const isEmail = (v: string) => EMAIL.test(v.trim());
export const EMAIL_MESSAGE = 'Enter a valid email address, e.g. name@company.com';

/** "Write at least 80 characters (you have 12)"; null when long enough. */
export const minChars = (value: string, min: number, what = 'at least') => {
  const n = value.trim().length;
  return n >= min ? null : n === 0 ? `This is required (${what} ${min} characters)` : `Write ${what} ${min} characters (you have ${n})`;
};
